import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { track } from "../lib/api";

/**
 * Subtle post-conversion "Next step" prompt card.
 * Restrained styling — matches the Stamp Duty → Snapshot nudge already in place.
 *
 * Emits TWO analytics events on click:
 *   1. The canonical CTA event (e.g. conveyancing_cta_clicked) so it feeds
 *      the existing commercial-action digest headline.
 *   2. A diagnostic `next_step_clicked` event carrying the post-conversion
 *      placement (e.g. post_survey_next_step) so cross-service journeys can
 *      be measured without double-counting the physical click.
 */
const NextStepPromptCard = ({
  icon: Icon,
  eyebrow,
  title,
  body,
  to,
  ctaEvent, // canonical event name (e.g. "conveyancing_cta_clicked")
  ctaLocation, // e.g. "post_survey_next_step"
  testid,
}) => {
  const onClick = () => {
    if (ctaEvent) {
      track(ctaEvent, { cta_location: ctaLocation, source: ctaLocation });
    }
    track("next_step_clicked", { cta_location: ctaLocation });
  };
  return (
    <Link
      to={to}
      onClick={onClick}
      data-testid={testid || `next-step-${ctaLocation}`}
      className="block rounded-2xl border border-[#DCE7E3] bg-gradient-to-br from-[#0F766E]/5 via-white to-[#10B981]/5 hover:border-[#0F766E]/50 hover:from-[#0F766E]/8 hover:via-white hover:to-[#10B981]/8 transition-all p-5 sm:p-6 group text-left"
    >
      <div className="flex items-center gap-4 sm:gap-5">
        {Icon && (
          <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-[#10B981]/12 border border-[#10B981]/25 flex items-center justify-center shrink-0" aria-hidden="true">
            <Icon className="w-5 h-5 text-[#0B5F58]" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          {eyebrow && <div className="text-[11px] uppercase tracking-widest text-[#0F766E]">{eyebrow}</div>}
          <div className="font-sora text-lg sm:text-xl font-semibold text-[#0B1220] mt-0.5 group-hover:text-[#0F766E] transition-colors">
            {title}
          </div>
          {body && <p className="mt-1 text-sm text-[#475569] leading-relaxed">{body}</p>}
        </div>
        <ArrowRight className="w-5 h-5 text-[#0F766E] shrink-0 hidden sm:block group-hover:translate-x-0.5 transition-transform" aria-hidden="true" />
      </div>
    </Link>
  );
};

export default NextStepPromptCard;
